import React from 'react';

const ContentWrapper = ({ children }) => {
    return <div className='page-content'>{children}</div>;
};

export default ContentWrapper;
